import { Alchemy, Network } from 'alchemy-sdk';

export const ethereumAlchemyClient = new Alchemy({
  apiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY,
  network:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? Network.ETH_MAINNET
      : Network.ETH_SEPOLIA,
});

export const baseAlchemyClient = new Alchemy({
  apiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY,
  network:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? Network.BASE_MAINNET
      : Network.BASE_SEPOLIA,
});
